import React from 'react';
import { Check, Info } from 'lucide-react';

const Pricing = () => {
  const pricingCategories = [
    {
      title: "Skimming Prices",
      items: [
        { name: "Small Room", price: "£550" },
        { name: "Medium Room", price: "£750" },
        { name: "Large Room", price: "£950" },
        { name: "Staircase / Landing / Hallways", price: "£1,700" },
        { name: "Patches", price: "From £250" }
      ]
    },
    {
      title: "Artex Ceilings",
      items: [
        { name: "Small", price: "£450" },
        { name: "Medium", price: "£550" },
        { name: "Large", price: "£650" }
      ]
    },
    {
      title: "Full Properties",
      items: [
        { name: "2 Bedroom House", price: "£4,500" },
        { name: "3 Bedroom House", price: "£5,500" },
        { name: "4 Bedroom House", price: "£7,500" }
      ]
    }
  ];

  return (
    <section id="pricing" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">Transparent Pricing</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">Our Price List</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Clear, upfront pricing with no hidden costs. All prices include labour and materials.
          </p>
        </div>

        {/* Pricing grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {pricingCategories.map((category, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-slate-100"
            >
              {/* Category header */}
              <div className="bg-slate-800 px-6 py-5">
                <h3 className="text-xl font-bold text-white">{category.title}</h3>
              </div>

              {/* Price items */}
              <div className="p-6">
                <ul className="space-y-4">
                  {category.items.map((item, itemIndex) => (
                    <li 
                      key={itemIndex} 
                      className="flex items-center justify-between pb-4 border-b border-slate-100 last:border-0 last:pb-0"
                    >
                      <div className="flex items-center gap-3">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        <span className="text-slate-700 font-medium">{item.name}</span>
                      </div>
                      <span className="text-amber-600 font-bold text-lg">{item.price}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-12 bg-amber-50 border border-amber-200 rounded-xl p-6 flex items-start gap-4">
          <Info className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-amber-800 font-medium mb-1">* Guide prices only</p>
            <p className="text-amber-700 text-sm">
              Final prices may vary depending on the condition of walls, accessibility, and specific requirements. 
              Contact us for a free, no-obligation quote tailored to your project.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-4 rounded-lg shadow-lg shadow-amber-200 transition-all hover:shadow-xl"
          >
            Get Your Free Quote
          </a>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
